import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { REPORTS } from "@/constants/testIds";

const BRAND_COLOR = "#8C7D70";

/** Grafico de ingresos a lo largo del periodo elegido (Dashboard + Reportes de Ingresos). */
export default function RevenueChart({ data, testId = REPORTS.revenueChart }) {
  return (
    <div className="bg-white border border-border rounded-xl p-5" data-testid={testId}>
      <h3 className="text-sm font-medium text-foreground mb-3">Ingresos en el periodo</h3>
      {data.length === 0 ? (
        <p className="text-sm text-muted-foreground py-10 text-center">Sin ingresos registrados en este periodo.</p>
      ) : (
        <ResponsiveContainer width="100%" height={240}>
          <AreaChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 4 }}>
            <defs>
              <linearGradient id="revenueFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={BRAND_COLOR} stopOpacity={0.35} />
                <stop offset="100%" stopColor={BRAND_COLOR} stopOpacity={0.02} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E8DFD8" />
            <XAxis dataKey="label" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} width={55} />
            <Tooltip formatter={(value) => [`$${Number(value).toFixed(2)}`, "Ingresos"]} />
            <Area type="monotone" dataKey="amount" stroke={BRAND_COLOR} strokeWidth={2} fill="url(#revenueFill)" />
          </AreaChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
